// extracted by mini-css-extract-plugin
export default {"zr-table":"OrderList_zr-table__R0F18","table-header":"OrderList_table-header__U8EwU"};